import { SimpleForm, Tab, TabProps } from 'react-admin';
import { CreateStyled } from '@/styles/overrides';
import FormContent from './FormContent';

const RunRunMvrTab = (props: Partial<TabProps>) => (
  <Tab label="Run MVR" {...props}>
    <CreateStyled title="Request MVR Script" {...props}>
      <SimpleForm mode="onChange" reValidateMode="onChange" toolbar={false}>
        <FormContent />
      </SimpleForm>
    </CreateStyled>
  </Tab>
);

export default RunRunMvrTab;
